import { render, staticRenderFns } from "./RecurrenceRule.vue?vue&type=template&id=b2c45a9c&scoped=true"
import script from "./RecurrenceRule.vue?vue&type=script&lang=ts"
export * from "./RecurrenceRule.vue?vue&type=script&lang=ts"
import style0 from "./RecurrenceRule.vue?vue&type=style&index=0&id=b2c45a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c45a9c",
  null
  
)

export default component.exports